module.exports = __webpack_public_path__ + "static/media/infoHome.dd9fb932.png";